import type { RootState } from './types';

import * as Sentry from '@sentry/browser';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { html } from 'react-strict-dom';

import AppAuthed from './AppAuthed';
import AnalyticsTracker from './components/AnalyticsTracker';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import { AnalyticsContextProvider } from './contexts';
import * as Auth from './pods/auth';

export default function App() {
  const { user } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  React.useEffect(() => {
    Sentry.setUser(user && { email: user.email });
  }, [user]);

  return (
    <html.div>
      <ScrollToTop />
      {/* Reset (without remounting) when the route or signed-in user changes,
          so a broken page doesn't wedge the app and sign-out escapes it. */}
      <ErrorBoundary
        resetKey={`${location.pathname}:${user ? user.id : 'anonymous'}`}
      >
        {user ? (
          <AnalyticsContextProvider>
            <AnalyticsTracker />
            <AppAuthed />
          </AnalyticsContextProvider>
        ) : (
          <Routes>
            <Route path="/login" element={<Auth.LoginPage />} />
            <Route
              path="/reset-password/:email/:hash"
              element={<Auth.ResetPasswordPage />}
            />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        )}
      </ErrorBoundary>
    </html.div>
  );
}
